var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slide-y-transition',[_c(_vm.component,{tag:"component",on:{"policyAccepted":function($event){_vm.dataPolicyAccepted=true},"resetdatapolicy":function($event){_vm.dataPolicyAccepted=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }